import {
    Box,
    Link as ChakraLink,
    IconButton,
    Text,
    Tooltip,
} from '@chakra-ui/react';
import { MdDialpad } from 'react-icons/md';
import { Link, useLocation } from 'react-router-dom';

const ManageNumbers = ({
    cardStatus,
    isTrialExpired,
    darkMode,
    numbersPath,
}) => {
    const { pathname } = useLocation();
    return cardStatus?.statusLabel === 'Healthy' && !isTrialExpired ? (
        <Box
            className="mb-[15px] flex justify-between"
            style={{ width: '60%' }}>
            <Text className="font-medium">Manage Numbers:</Text>

            <span className="mx-1 inline-flex flex-shrink-0 self-center">
                <Tooltip
                    label="Associate and Manage Mobile Operator Accounts and Numbers"
                    hasArrow
                    placement="bottom">
                    <ChakraLink
                        as={Link}
                        to={`/${numbersPath}`}
                        state={{
                            from: pathname,
                        }}>
                        <IconButton
                            icon={
                                <MdDialpad
                                    icon="Settings"
                                    color={darkMode ? 'white' : 'black'}
                                />
                            }
                            size="xs"
                            bg="transparent"
                            _hover={{ bg: 'transparent' }}
                            _active={{ bg: 'transparent' }}
                            _focus={{ bg: 'transparent' }}
                            onClick={() => {}}
                        />
                    </ChakraLink>
                </Tooltip>
            </span>
        </Box>
    ) : (
        <Box
            minH="21px"
            mb="15px"
            display="flex"
            aria-label="hidden"
            aria-hidden={true}
        />
    );
};

export default ManageNumbers;
